import { helper } from "@ember/component/helper"
import { isUnifiedCardStack } from "@shared/lib/card-stack/unified-migration"
import type { CardStack } from "@shared/models/card-stack"

export function isUnifiedCardStackHelperFn(args: [CardStack]) {
  let [cardStack] = args
  return isUnifiedCardStack(cardStack)
}

const isUnifiedCardStackHelper = helper(isUnifiedCardStackHelperFn)
export default isUnifiedCardStackHelper

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "is-unified-card-stack": typeof isUnifiedCardStackHelper
  }
}
